export default __webpack_public_path__ + "static/media/oscer-pres-constipation.cd670259.svg";